import {observer} from "mobx-react-lite";
import styles from "./Form.module.scss";
import {FC, FormEvent} from "react";
import {TFieldProps, TFooterProps, TFormRootProps, THeaderProps} from "../../auth/Form/types";
import {Typography} from "@shared/ui/Typography/Typography";



export const FormRoot: FC<TFormRootProps> = observer(({children, title, onSubmit, ...props}) => {

    const onSubmitHandler = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (onSubmit) {
            onSubmit()
        }
    }

    return (
        <form className={styles.root} onSubmit={onSubmitHandler} {...props}>
            {title &&
                <Typography adaptiveFontSize={1} fontWeight={"bold"} align={"center"}>
                    {title}
                </Typography>
            }
            {children}
        </form>
    )
})

export const Header: FC<THeaderProps> = observer(({children}) => {

    return (
        <div className={styles.header}>
            {children}
        </div>
    )
})

export const Field: FC<TFieldProps> = observer(({children}) => {

    return (
        <div className={styles.field}>
            {children}
        </div>
    )
})

export const Footer: FC<TFooterProps> = observer(({children}) => {

    return (
        <div className={styles.footer}>
            {children}
        </div>
    )
})

export const Error: FC<{text: string, isVisible?: boolean}> = observer(({text, isVisible}) => {

    if (!isVisible) {
        return null
    }

    return (
        <Typography color={'rgba(207,37,37,0.7)'} align={"center"} fontWeight={"bold"}>
            {text}
        </Typography>
    )
})

